import cn from "classnames";
import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import DropdownBtn from "components/shared/dropdown";
import { DatetimeRange } from "components/shared/form";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView, defDatetimeRangeFilter } from "helpers/date";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { getOrganizationNames } from "sources/admin";
import { cancelLastNeuralNetworkTask } from "sources/admin/neuralNetwork";
import { resetCaches } from "sources/admin/registryPoints";
import CollectRegistryPoints from "./collectRegistryPoints";
import LastCollectingTask from "./lastCollectingTask";
import LastNeuralNetworkTask from "./lastNeuralNetworkTask";
import StartNeuralNetworkTraining from "./startNeuralNetworkTraining";

class NeutalNetworkLogs extends BookIndex {
    componentWillUnmount() {
        this.props.clearParams(defDatetimeRangeFilter("date"));
    }

    get tableColumns() {
        return [
            {
                Header: "Дата",
                accessor: "date",
                filterable: false,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            { Header: "ID заявки", accessor: "bidId", filterable: true, filterType: "int" },
            { Header: "ID точки заявки", accessor: "bidPointId", filterable: true, filterType: "int" },
            {
                Header: "Организация",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({
                    row: {
                        original: { organizationName, organizationId },
                    },
                }) =>
                    organizationName &&
                    organizationId && <Link to={paths.adminOrganizationsShow(organizationId)}>{organizationName}</Link>,
            },
            { Header: "Новый адрес", accessor: "newAddress", filterable: true },
            {
                Header: "Успешность запроса",
                accessor: "isSuccessful",
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Успешные", value: "true" },
                        { label: "Не успешные", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} />;
                },
                Cell: ({ value }) => (
                    <div className={cn({ "text-success": value, "text-danger": !value })}>
                        {value ? "Успешно" : "Не успешно"}
                    </div>
                ),
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            { Header: "Текст ошибки", accessor: "error", filterable: true },
        ];
    }

    get dropdownActions() {
        const { modal } = this.props;
        return [
            {
                text: "Запустить обучение",
                action: () =>
                    modal({
                        name: "default",
                        title: "Запуск обучения",
                        windowMod: "sm",
                        CustomBody: StartNeuralNetworkTraining,
                    }),
            },
            {
                text: "Информация о последнем запуске обучения",
                action: () =>
                    modal({
                        name: "default",
                        title: "Информация о последнем запуске обучения",
                        windowMod: "sm",
                        CustomBody: LastNeuralNetworkTask,
                    }),
            },
            {
                text: "Остановка обучения",
                action: () =>
                    modal({
                        name: "confirm",
                        title: "Остановить обучение?",
                        action: cancelLastNeuralNetworkTask,
                        buttons: { confirm: "Да", cancel: "Нет" },
                    }),
            },
            {
                text: "Собрать реестр точек",
                action: () =>
                    modal({
                        name: "default",
                        title: "Запуск обучения",
                        windowMod: "sm",
                        CustomBody: CollectRegistryPoints,
                    }),
            },
            {
                text: "Информация о cборе реестра точек",
                action: () =>
                    modal({
                        name: "default",
                        title: "Информация о cборе реестра точек",
                        windowMod: "wide",
                        CustomBody: LastCollectingTask,
                    }),
            },
            {
                text: "Сбросить кэш",
                action: () =>
                    modal({
                        name: "confirm",
                        title: "Сбросить кэш?",
                        action: resetCaches,
                        buttons: { confirm: "Да", cancel: "Нет" },
                    }),
            },
        ];
    }

    renderHead = () => {
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">Логи нейронной сети</div>
                <div className="btn-toolbar">
                    <DropdownBtn text="Управление" items={this.dropdownActions} contentCname="font-size-14" />
                </div>
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list book-list--nofilter">
                        {this.renderHead()}
                        <div className="container-fluid my-2">
                            <DatetimeRange name="date" {...this.props} />
                        </div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(NeutalNetworkLogs, "neural-network-logs");
